class ProductTabs {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.tabButtons = this.container.querySelectorAll(
      ".product-tabs__tab-item"
    );
    this.tabContents = this.container.querySelectorAll(
      ".product-tabs__tab-content"
    );
    this.bindEvents();
  }

  bindEvents() {
    this.handleTabClick = this.handleTabClick.bind(this);
    this.container.addEventListener("click", this.handleTabClick);
  }

  handleTabClick(event) {
    const clickedTab = event.target.closest(".product-tabs__tab-item");
    if (!clickedTab) return;

    event.preventDefault();
    const tabId = clickedTab.getAttribute("data-tab-id");

    this.tabButtons.forEach((button) => button.classList.remove("active"));
    this.tabContents.forEach((content) => content.classList.remove("active"));

    clickedTab.classList.add("active");
    this.container.querySelector(`#${tabId}`).classList.add("active");
  }

  onSectionLoad() {
    this.init();
  }

  onSectionUnload() {
    this.container.removeEventListener("click", this.handleTabClick);
  }

  onBlockSelect(event) {
    const tabId = event.target.id;
    const tabButton = this.container.querySelector(`[data-tab-id="${tabId}"]`);
    if (tabButton) {
      tabButton.click();
    }
  }
}

// Shopify Theme Editor Events
function handleSectionLoad(event) {
  if (event.target.classList.contains("product-tabs")) {
    if (event.target.productTabs) {
      event.target.productTabs.onSectionUnload();
    }
    event.target.productTabs = new ProductTabs(event.target);
  }
}

function handleSectionUnload(event) {
  if (
    event.target.classList.contains("product-tabs") &&
    event.target.productTabs
  ) {
    event.target.productTabs.onSectionUnload();
    delete event.target.productTabs;
  }
}

function handleBlockSelect(event) {
  const section = event.target.closest(".product-tabs");
  if (section && section.productTabs) {
    section.productTabs.onBlockSelect(event);
  }
}

document.addEventListener("shopify:section:load", handleSectionLoad);
document.addEventListener("shopify:section:unload", handleSectionUnload);
document.addEventListener("shopify:block:select", handleBlockSelect);

// Initialize on page load and reinitialize on Shopify Theme Editor changes
document.addEventListener("DOMContentLoaded", initProductTabs);
document.addEventListener("shopify:section:load", initProductTabs);

function initProductTabs() {
  document.querySelectorAll(".product-tabs").forEach((container) => {
    if (container.productTabs) {
      container.productTabs.onSectionUnload();
    }
    container.productTabs = new ProductTabs(container);
  });
}

class ProductTabContent {
  constructor(options) {
    this.contentContainer = document.querySelector(options.contentSelector);
    this.videoWrapper = document.querySelector(options.videoSelector);
    this.videoColumn = document.querySelector(options.columnSelector);
    this.startHeading = options.startHeading;
    this.endHeading = options.endHeading;

    // Get the raw HTML content
    const descriptionContainer = document.querySelector(
      options.descriptionSelector
    );
    this.description = descriptionContainer
      ? descriptionContainer.innerHTML
      : "";

    if (this.contentContainer && this.videoWrapper) {
      this.init();
    }
  }

  init() {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = this.description;

    // Find the start and end points
    const headings = Array.from(tempDiv.getElementsByTagName("h5"));
    const startPoint = this.startHeading
      ? headings.find((h5) => h5.textContent.trim() === this.startHeading)
      : tempDiv.firstChild;
    const endPoint = this.endHeading
      ? headings.find((h5) => h5.textContent.trim() === this.endHeading)
      : null;

    // Create wrapper for content
    const contentWrapper = document.createElement("div");
    let hasContent = false;
    let foundVideo = false;

    // Get content between start and end points
    let currentNode = this.startHeading ? startPoint : tempDiv.firstChild;
    while (currentNode && currentNode !== endPoint) {
      // Check for iframe
      let iframe = null;
      if (currentNode.nodeType === Node.ELEMENT_NODE) {
        iframe =
          currentNode.tagName === "IFRAME"
            ? currentNode
            : currentNode.querySelector("iframe");
      }

      if (iframe) {
        // Move iframe to video wrapper
        const iframeCopy = iframe.cloneNode(true);
        iframeCopy.style.position = "absolute";
        iframeCopy.style.top = "0";
        iframeCopy.style.left = "0";
        iframeCopy.style.width = "100%";
        iframeCopy.style.height = "100%";
        this.videoWrapper.appendChild(iframeCopy);
        foundVideo = true;

        // If the iframe is the current node, skip it
        if (currentNode === iframe) {
          currentNode = currentNode.nextSibling;
          continue;
        }
      }

      // Add non-video content
      if (currentNode.nodeType === Node.TEXT_NODE) {
        if (currentNode.textContent.trim()) {
          contentWrapper.appendChild(currentNode.cloneNode(true));
          hasContent = true;
        }
      } else {
        // Clone the node without the iframe if it exists
        const clonedNode = currentNode.cloneNode(true);
        const nestedIframe = clonedNode.querySelector("iframe");
        if (nestedIframe) {
          nestedIframe.remove();
        }
        contentWrapper.appendChild(clonedNode);
        hasContent = true;
      }

      currentNode = currentNode.nextSibling;
    }

    // Update content
    if (hasContent) {
      this.contentContainer.innerHTML = contentWrapper.innerHTML;
    } else {
      this.contentContainer.innerHTML = "<p>No content available</p>";
      this.contentContainer.parentElement.style.width = "100%";
    }

    // Handle video column
    if (!foundVideo) {
      this.videoColumn.style.display = "none";
      this.contentContainer.parentElement.style.width = "100%";
    }
  }

  // Add a static method to scan for available sections
  static scanForSections() {
    const descriptionContainer = document.querySelector(
      "#product-description-data"
    );
    if (!descriptionContainer) return [];

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = descriptionContainer.innerHTML;

    // Get all h5 headings, but exclude "Description" since it's our default tab
    const headings = Array.from(tempDiv.getElementsByTagName("h5"))
      .map((h5) => h5.textContent.trim())
      .filter((heading) => heading !== "Description"); // Filter out "Description" heading

    return headings;
  }
}

// Initialize tab content when DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  // Scan for available sections
  const sections = ProductTabContent.scanForSections();

  // Always initialize Description tab (content before first h5 or until "Details")
  if (document.querySelector("#description-content")) {
    new ProductTabContent({
      contentSelector: "#description-content",
      videoSelector: "#description-video .fluid-width-video-wrapper",
      columnSelector: ".description-container__video-column",
      endHeading: "Details", // Always end at Details instead of first h5
      descriptionSelector: "#product-description-data",
    });
  }

  // Initialize Details tab if it exists
  if (
    document.querySelector("#details-content") &&
    sections.includes("Details")
  ) {
    new ProductTabContent({
      contentSelector: "#details-content",
      videoSelector: "#details-video .fluid-width-video-wrapper",
      columnSelector: ".details-container__video-column",
      startHeading: "Details",
      endHeading: sections[sections.indexOf("Details") + 1], // End at next heading if exists
      descriptionSelector: "#product-description-data",
    });
  }

  // Initialize any additional tabs found
  sections.forEach((heading, index) => {
    if (heading !== "Details") {
      // Skip Details since we handled it above
      const elementId = `content-${heading.toLowerCase().replace(/\s+/g, "-")}`;
      if (document.querySelector(`#${elementId}`)) {
        new ProductTabContent({
          contentSelector: `#${elementId}`,
          videoSelector: `#video-${elementId} .fluid-width-video-wrapper`,
          columnSelector: `.${elementId}-container__video-column`,
          startHeading: heading,
          endHeading: sections[index + 1], // End at next heading if exists
          descriptionSelector: "#product-description-data",
        });
      }
    }
  });
});
